<template>
<div class="container">
<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Book Exam</div>
<div class="panal-body">




<div class="form-group">
  <div class="form-row">
    <div class="col-6">
    <label>Location</label>
   <select class="form-control" v-model="ExamLocation.ExamLocationsID" @change="ShowDates">
  <option>Default select</option>
  <option v-for="location in LocationList" v-bind:key="location.ExamLocationsID" :value="location.ExamLocationsID">{{location.Location}}</option>
</select>

    
  </div>
  
<div class="col-6">
    <label>Date</label>
    <select class="form-control" v-model="ExamLocation.ExamDates" @change="ShowTimes">
  <option>Default select</option>
  <option v-for="date in DatesList" v-bind:key="date.ExamDate">{{date.ExamDate}}</option>
</select>
    
  </div>
 <div class="col-6 mt-3">
    <label>Time</label>
   <select class="form-control" v-model="ExamLocation.ExamDateID" >
  <option>Default select</option>
  <option v-for="Time in TimesList" :value="Time.Serial" v-bind:key="Time.Serial">{{Time.ExamTimeFrom}} - {{Time.ExamTimeTo}}</option>
</select>
    
  </div>

<div class="text-right col-12 mt-3">
    <button type="button" class="btn btn-primary mr-1" @click="BookApplicantExam">Book Exam</button>
    <button type="reset" class="btn btn-success" @click="Cancel">Cancel</button>

</div>
</div>
</div>





<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Confirm</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Please Review Details carfully 
        {{ExamLocation.Location}} --  {{ExamLocation.ExamDates}} -- {{ExamLocation.ExamDates}}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Back</button>
        <button type="button" class="btn btn-primary">Submit</button>
      </div>
    </div>
  </div>
</div>





</div>

</div>
</div>
</div>
</div>



</template>

<script>
import ApplicantService from '../../services/Applicant/Applicant.service'
import { ExamLocation } from '../../models/Applicant';
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services';
export default{
  data(){
    return{
        LocationList : [],
        DatesList : [],
        TimesList : [],
        ExamLocation : new ExamLocation('','','','','',''),
        selectedDate: '',
        message:''
    }
  },
  mounted(){
    let ExamID = localStorage.getItem('ExamID')
         this.ExamLocation.ApplicantExamID = localStorage.getItem('examSerial')

    ApplicantService.PostExamDatesLocationsAPI(ExamID ,this.ExamLocation.ApplicantExamID).then(Response =>{
          this.LocationList=Response.data
           
        }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });
  },
  methods:{
    ShowDates(){
     
     this.ExamLocation.ApplicantExamID = localStorage.getItem('examSerial')
     this.ExamLocation.ExamID = localStorage.getItem('ExamID')
      ApplicantDataServices.PostApplicant_ExamDates_SelectUpComingExamDateByLocationAPI(this.ExamLocation).then(Response =>{
          this.DatesList=Response.data
           
        }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });
    },
    ShowTimes(){
     this.ExamLocation.ExamID = localStorage.getItem('ExamID')


    ApplicantDataServices.GetApplicantExamTimes(this.ExamLocation).then(Response =>{
          this.TimesList=Response.data
           
        }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });
    },
    BookApplicantExam(){
     this.ExamLocation.ApplicantExamID = localStorage.getItem('examSerial')
     this.ExamLocation.ApplicantID = this.currentUser.UserIDSerial

     ApplicantDataServices.BookApplicantExam(this.ExamLocation).then(Response =>{
          this.message=Response.data
           setTimeout(this.Cancel(),5000)
        }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });

    }
    , Cancel() {
          
      this.$emit('clicked', this.selected = 0 )
    }
  },
    computed:{
     currentUser(){
     return this.$store.state.auth.user
   }
    }
} 
</script>

<style scoped>

table tr th {
    background-color: #4caf5000 !important;
    color:#333;
    font-weight:bold;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}
.app-stu-photo{
    float:right;
    width:200px;
    border-radius:10px;
    border:1px solid #111;
    margin-top:20px;
}
.app-stu-photo img{
    width:100%;
      border-radius:10px;
      
}
.app-All{
    width:80%;
    float:left;
}
.app-stu{
    border-bottom:1px #333 dotted;
    padding:10px 0px;

}
.app-stu .title{
    font-weight:bold;

}

.app-stu .title span{
    font-weight: 100;


    
}

.table .thead-dark th {
    color: #fff;
    background-color: #dee2e6 !important;
    border-color: #989899 !important;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

</style>